import React, { cloneElement, ReactElement, useEffect, useState } from 'react'

export interface BannersProps {
  children?: ReactElement[]
}

export const Banners = ({ children = [] }: BannersProps) => {
  const [index, setIndex] = useState<number>(0)
  const banners = React.Children.toArray(children)

  // Make sure we don't go out of bounds (i.e. if the last banner is closed)
  useEffect(() => {
    if (index !== 0 && banners.length === index) {
      setIndex(banners.length - 1)
    }
    // eslint-disable-next-line
  }, [banners.length])

  if (banners.length === 0 || banners.length === index) {
    return null
  }

  // Don't add navigation on a single banner
  if (banners.length === 1) {
    return <>{children}</>
  }

  const goToNextBanner = () => {
    const nextIndex = index === children.length - 1 ? 0 : index + 1
    setIndex(nextIndex)
  }

  const goToPreviousBanner = () => {
    const previousIndex = index === 0 ? children.length - 1 : index - 1
    setIndex(previousIndex)
  }

  return (
    <>
      {cloneElement(children[index], {
        showNav: true,
        onPrevious: goToPreviousBanner,
        onNext: goToNextBanner,
      })}
    </>
  )
}
